import { transformCdnImageUrl } from "seneca-common/utils/images";

import { ContentSource, ImageAssetParameters } from "../types";

export function getModuleAssets(source: ContentSource): Array<string> {
  return source.imageUrl ? [source.imageUrl] : [];
}

export function transformModuleAssets(
  source: ContentSource,
  assetParams: ImageAssetParameters
): ContentSource {
  if (source.imageUrl) {
    return {
      ...source,
      imageUrl: transformCdnImageUrl(source.imageUrl, assetParams.default)
    };
  }

  return source;
}
